import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  color: #000;

  .ck.ck-editor {
    width: 100%;
  }

  .cke_inner {
    width: 100%;
    min-width: 100% !important;
  }

  .ck-editor__main .ck-editor__editable_inline {
    min-height: 6.2rem;
    width: 100%;
    min-width: 100% !important;
  }

  .cke_button_label {
    display: none !important;
  }

  .cke_toolbar {
    display: flex !important;
    justify-content: space-around !important;
  }

  [class$="_label"] {
    display: none !important;
  }

  #cke_1_toolbox {
    display: flex !important;
  }
`;
